// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Chatbox Styles */
.ai-chatbox {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 350px;
  height: 500px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  font-family: 'Poppins', sans-serif;
  display: none;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
}

.ai-chatbox.open {
  display: flex;
}

body.no-scroll {
  overflow: hidden !important;
}

.chatbox-header {
  background: #173058;
  padding: 16px 20px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  border-radius: 12px 12px 0 0;
}

.chatbox-title {
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 140px;
}

.ai-icon {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  background: #6b7280;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  position: relative;
  flex-shrink: 0;
}

.ai-icon-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.close-btn {
  background: none;
  border: none;
  color: rgb(176, 172, 172);
  font-size: 25px;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  transition: background 0.2s;
  flex-shrink: 0;
  min-width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.chatbox-messages {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
  background: white;
  display: flex;
  flex-direction: column;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.message {
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.4;
  animation: slideIn 0.3s ease;
  position: relative;
}

.message-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.message-wrapper.user {
  align-items: flex-end;
}

.message-wrapper.ai {
  align-items: flex-start;
}

.message-time {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 6px;
  font-weight: 400;
  text-align: right;
}

.message.ai .message-time {
  color: #9ca3af;
  text-align: left;
}

.message-content {
  line-height: 1.4;
}

.message.user {
  background: #173058;
  color: white;
  border-radius: 18px 18px 6px 18px;
}

.message.ai {
  background: #ECEEF2;
  color: #374151;
  border-radius: 18px 18px 18px 6px;
  border: 1px solid #e5e7eb;
}

.message.ai strong {
  color: #333;
  font-weight: 600;
}

.message.ai ol, .message.ai ul {
  margin: 8px 0;
  padding-left: 20px;
}

.message.ai li {
  margin-bottom: 12px;
  line-height: 1.5;
}

.message.ai p {
  margin: 8px 0;
  line-height: 1.5;
}

.message.system {
  margin: 10px 0;
  text-align: center;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
  color: #856404;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  align-self: center;
  max-width: 90%;
}

.message.thinking {
  background: #fef3c7;
  color: #92400e;
  align-self: flex-start;
  border-radius: 18px 18px 18px 6px;
  margin-right: 20%;
  border: 1px solid #fbbf24;
  padding: 12px 16px;
  max-width: 80%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.thinking-dots {
  display: flex;
  gap: 4px;
}

.thinking-dot {
  width: 6px;
  height: 6px;
  background: #92400e;
  border-radius: 50%;
  animation: thinking-pulse 1.4s infinite ease-in-out;
}

.thinking-dot:nth-child(1) { animation-delay: 0s; }
.thinking-dot:nth-child(2) { animation-delay: 0.2s; }
.thinking-dot:nth-child(3) { animation-delay: 0.4s; }

.system-banner {
  background: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.3);
  color: #721c24;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  margin: 10px 0;
  text-align: center;
}

.chatbox-input {
  padding: 16px 20px;
  background: white;
  display: flex;
  gap: 9px;
  align-items: center;
}

.message-input {
  flex: 1 1;
  padding: 12px 16px;
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  outline: none;
  transition: all 0.2s;
  background: #f9fafb;
  color: #9ca3af;
}

.message-input:focus {
  border-color: #173058;
  background: white;
  color: #374151;
}

.message-input:disabled {
  background: #ECEEF2;
  color: #6c757d;
  cursor: not-allowed;
}

.send-btn {
  background: #173058;
  border: none;
  color: white;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.send-btn:hover:not(:disabled) {
  background: #1e3a8a;
}

.send-btn:disabled {
  background: #6c757d;
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.send-btn-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.chat-toggle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: #173058;
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
  z-index: 10001;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-toggle:hover {
  background: #1e40af;
  box-shadow: 0 6px 16px rgba(30, 58, 138, 0.4);
}

.chat-toggle.hidden {
  display: none;
}

.chat-toggle-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.message-counter {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.message-counter.normal {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.message-counter.warning {
  background: rgba(255, 193, 7, 0.9);
  color: #000;
}

.message-counter.critical {
  background: rgba(220, 53, 69, 0.9);
  color: #fff;
  animation: pulse 2s infinite;
}

.conversation-separator {
  display: flex;
  align-items: center;
  margin: 20px 0;
  text-align: center;
  position: relative;
}

.conversation-separator::before {
  content: '';
  flex: 1 1;
  height: 1px;
  background: linear-gradient(to right, transparent, #e9ecef, transparent);
}

.conversation-separator span {
  padding: 0 15px;
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
  background: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.conversation-separator.current span {
  color: #667eea;
  font-weight: 600;
}

.conversation-separator.current::before {
  background: linear-gradient(to right, transparent, #667eea, transparent);
}

.single-line-separator {
  margin: 15px 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
}

.single-line-separator hr {
  border: none !important;
  height: 1px !important;
  background: #e9ecef !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
}

.simple-text-separator {
  text-align: center;
  margin: 15px 0;
  position: relative;
}

.simple-text-separator::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #e9ecef;
  z-index: 1;
}

.simple-text-separator span {
  background: white;
  padding: 0 15px;
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 2;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}

@keyframes thinking-pulse {
  0%, 60%, 100% {
    transform: scale(1);
    opacity: 0.4;
  }
  30% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .ai-chatbox {
    width: calc(100vw - 40px);
    height: calc(100vh - 40px);
    height: calc(100dvh - 40px);
    max-height: calc(100lvh - 40px);
    bottom: 20px;
    right: 20px;
    left: 20px;
    border-radius: 15px;
  }
  
  .chat-toggle {
    bottom: 15px;
    right: 15px;
  }

  .chatbox-header {
    padding: calc(15px + env(safe-area-inset-top, 0px)) 15px 15px 15px;
    gap: 6px;
  }
  
  .chatbox-title {
    font-size: 13px;
    min-width: 120px;
  }
  
  .message-counter {
    font-size: 11px;
    padding: 3px 6px;
  }

  .chatbox-messages {
    padding: 15px;
  }

  .chatbox-input {
    padding: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Chatbot/chatbot.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;;AAEpD;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,wEAAwE;AAC1E;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kEAAkE;IAClE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* AI Chatbox Styles */\n.ai-chatbox {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 350px;\n  height: 500px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  z-index: 10000;\n  font-family: 'Poppins', sans-serif;\n  display: none;\n  flex-direction: column;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  border: 1px solid #e5e7eb;\n  box-sizing: border-box;\n}\n\n.ai-chatbox.open {\n  display: flex;\n}\n\nbody.no-scroll {\n  overflow: hidden !important;\n}\n\n.chatbox-header {\n  background: #173058;\n  padding: 16px 20px;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  border-radius: 12px 12px 0 0;\n}\n\n.chatbox-title {\n  font-weight: 600;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 140px;\n}\n\n.ai-icon {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  min-height: 40px;\n  background: #6b7280;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.ai-icon-img {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: rgb(176, 172, 172);\n  font-size: 25px;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 50%;\n  transition: background 0.2s;\n  flex-shrink: 0;\n  min-width: 35px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.chatbox-messages {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n  background: white;\n  display: flex;\n  flex-direction: column;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n.message {\n  max-width: 80%;\n  padding: 12px 16px;\n  border-radius: 18px;\n  font-size: 14px;\n  line-height: 1.4;\n  animation: slideIn 0.3s ease;\n  position: relative;\n}\n\n.message-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.message-wrapper.user {\n  align-items: flex-end;\n}\n\n.message-wrapper.ai {\n  align-items: flex-start;\n}\n\n.message-time {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-top: 6px;\n  font-weight: 400;\n  text-align: right;\n}\n\n.message.ai .message-time {\n  color: #9ca3af;\n  text-align: left;\n}\n\n.message-content {\n  line-height: 1.4;\n}\n\n.message.user {\n  background: #173058;\n  color: white;\n  border-radius: 18px 18px 6px 18px;\n}\n\n.message.ai {\n  background: #ECEEF2;\n  color: #374151;\n  border-radius: 18px 18px 18px 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.message.ai strong {\n  color: #333;\n  font-weight: 600;\n}\n\n.message.ai ol, .message.ai ul {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.message.ai li {\n  margin-bottom: 12px;\n  line-height: 1.5;\n}\n\n.message.ai p {\n  margin: 8px 0;\n  line-height: 1.5;\n}\n\n.message.system {\n  margin: 10px 0;\n  text-align: center;\n  background: rgba(255, 193, 7, 0.1);\n  border: 1px solid rgba(255, 193, 7, 0.3);\n  color: #856404;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  align-self: center;\n  max-width: 90%;\n}\n\n.message.thinking {\n  background: #fef3c7;\n  color: #92400e;\n  align-self: flex-start;\n  border-radius: 18px 18px 18px 6px;\n  margin-right: 20%;\n  border: 1px solid #fbbf24;\n  padding: 12px 16px;\n  max-width: 80%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.thinking-dots {\n  display: flex;\n  gap: 4px;\n}\n\n.thinking-dot {\n  width: 6px;\n  height: 6px;\n  background: #92400e;\n  border-radius: 50%;\n  animation: thinking-pulse 1.4s infinite ease-in-out;\n}\n\n.thinking-dot:nth-child(1) { animation-delay: 0s; }\n.thinking-dot:nth-child(2) { animation-delay: 0.2s; }\n.thinking-dot:nth-child(3) { animation-delay: 0.4s; }\n\n.system-banner {\n  background: rgba(220, 53, 69, 0.1);\n  border: 1px solid rgba(220, 53, 69, 0.3);\n  color: #721c24;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 10px 0;\n  text-align: center;\n}\n\n.chatbox-input {\n  padding: 16px 20px;\n  background: white;\n  display: flex;\n  gap: 9px;\n  align-items: center;\n}\n\n.message-input {\n  flex: 1;\n  padding: 12px 16px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 14px;\n  font-family: 'Poppins', sans-serif;\n  outline: none;\n  transition: all 0.2s;\n  background: #f9fafb;\n  color: #9ca3af;\n}\n\n.message-input:focus {\n  border-color: #173058;\n  background: white;\n  color: #374151;\n}\n\n.message-input:disabled {\n  background: #ECEEF2;\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n.send-btn {\n  background: #173058;\n  border: none;\n  color: white;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.send-btn:hover:not(:disabled) {\n  background: #1e3a8a;\n}\n\n.send-btn:disabled {\n  background: #6c757d;\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.send-btn-icon {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.chat-toggle {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 60px;\n  height: 60px;\n  background: #173058;\n  border: none;\n  border-radius: 50%;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);\n  z-index: 10001;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chat-toggle:hover {\n  background: #1e40af;\n  box-shadow: 0 6px 16px rgba(30, 58, 138, 0.4);\n}\n\n.chat-toggle.hidden {\n  display: none;\n}\n\n.chat-toggle-icon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.message-counter {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.message-counter.normal {\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n}\n\n.message-counter.warning {\n  background: rgba(255, 193, 7, 0.9);\n  color: #000;\n}\n\n.message-counter.critical {\n  background: rgba(220, 53, 69, 0.9);\n  color: #fff;\n  animation: pulse 2s infinite;\n}\n\n.conversation-separator {\n  display: flex;\n  align-items: center;\n  margin: 20px 0;\n  text-align: center;\n  position: relative;\n}\n\n.conversation-separator::before {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(to right, transparent, #e9ecef, transparent);\n}\n\n.conversation-separator span {\n  padding: 0 15px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6c757d;\n  background: white;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.conversation-separator.current span {\n  color: #667eea;\n  font-weight: 600;\n}\n\n.conversation-separator.current::before {\n  background: linear-gradient(to right, transparent, #667eea, transparent);\n}\n\n.single-line-separator {\n  margin: 15px 0 !important;\n  padding: 0 !important;\n  background: transparent !important;\n  border: none !important;\n}\n\n.single-line-separator hr {\n  border: none !important;\n  height: 1px !important;\n  background: #e9ecef !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 100% !important;\n}\n\n.simple-text-separator {\n  text-align: center;\n  margin: 15px 0;\n  position: relative;\n}\n\n.simple-text-separator::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: #e9ecef;\n  z-index: 1;\n}\n\n.simple-text-separator span {\n  background: white;\n  padding: 0 15px;\n  font-size: 12px;\n  color: #6c757d;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: relative;\n  z-index: 2;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.7; }\n  100% { opacity: 1; }\n}\n\n@keyframes thinking-pulse {\n  0%, 60%, 100% {\n    transform: scale(1);\n    opacity: 0.4;\n  }\n  30% {\n    transform: scale(1.2);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .ai-chatbox {\n    width: calc(100vw - 40px);\n    height: calc(100vh - 40px);\n    height: calc(100dvh - 40px);\n    max-height: calc(100lvh - 40px);\n    bottom: 20px;\n    right: 20px;\n    left: 20px;\n    border-radius: 15px;\n  }\n  \n  .chat-toggle {\n    bottom: 15px;\n    right: 15px;\n  }\n\n  .chatbox-header {\n    padding: calc(15px + env(safe-area-inset-top, 0px)) 15px 15px 15px;\n    gap: 6px;\n  }\n  \n  .chatbox-title {\n    font-size: 13px;\n    min-width: 120px;\n  }\n  \n  .message-counter {\n    font-size: 11px;\n    padding: 3px 6px;\n  }\n\n  .chatbox-messages {\n    padding: 15px;\n  }\n\n  .chatbox-input {\n    padding: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
